export const knowledgeBaseRouteNames = {
  aiAgentsKnowledgeBase: 'ai-agents-knowledge-base',
  editKnowledgeBase: 'ai-agents-knowledge-base-edit',
  knowledgeBaseSettings: 'knowledge-base-settings',
}
